import { apiWrapper, apiCancel } from '../../wrapper'

export const initial = 'diklat'
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE
const outputType = 'json'

export const masterRegion = 'Master/Region/list/'

export const diklatList = 'Kepegawaian/Diklat/list/'
export const diklatCreate = 'Kepegawaian/Diklat/create/'
export const diklatDetail = 'Kepegawaian/Diklat/detail/'
export const diklatUpdate = 'Kepegawaian/Diklat/update/'
export const diklatInactive = 'Kepegawaian/Diklat/inactive/'
export const diklatActive = 'Kepegawaian/Diklat/active/'
export const diklatApprove = 'Kepegawaian/Diklat/approve/'

export const diklatTrainingList = 'Kepegawaian/Diklat/trainingList/'
export const diklatHours = 'Kepegawaian/Diklat/totalhours/'

export const admindiklatList = 'Kepegawaian/Diklat/listadmin/'
export const admindiklatCreate = 'Kepegawaian/Diklat/create/'
export const admindiklatDetail = 'Kepegawaian/Diklat/detail/'
export const admindiklatUpdate = 'Kepegawaian/Diklat/update/'
export const admindiklatInactive = 'Kepegawaian/Diklat/inactive/'
export const admindiklatActive = 'Kepegawaian/Diklat/active/'
export const admindiklatApprove = 'Kepegawaian/Diklat/approve/'

export const admindiklatTrainingList = 'Kepegawaian/Diklat/trainingList/'
export const admindiklatHours = 'Kepegawaian/Diklat/totalhours/'
export const admindiklatListPegawai = 'Kepegawaian/Diklat/list_pegawai/'

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
    return apiCancel()
}
export const apiRequest = async (method, route, data = { params: null, body: null, cancelToken: null }, needToken=true) => {
    if(needToken) {
        const thisTime = (Math.floor(Date.now()/1000))
        const expire = localStorage.getItem(initial + 'accessExpired')
        if(expire < thisTime) {
           await apiWrapper(baseUrl, initial, appCode, outputType, 'post', 'auth/getAccessToken/', data)
           .then(result => {
                localStorage.setItem(initial + 'accessToken', result.response.access_token)
                return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
            })
            .catch(result => {
                return Promise.reject('Tidak dapat mengambil accessToken');
            })
        } else {
            return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)        
        }
    }
    return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
}